export const dialogTitleStyles = {
  fontWeight: '550',
  fontSize: '1.75rem',
  color: '#1a1a1a',
  textAlign: 'center',
  padding: '16px 24px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginLeft: '3px',
};

export const closeIconButtonStyles = {
  color: '#808080',
  fontSize: '1.5rem',
};

export const alertStyles = {
  mt: 2,
};

export const addNewCustomerTypographyStyles = {
  cursor: 'pointer',
  textDecoration: 'underline',
  color: '#1976d2',
  '&:hover': {
    color: '#115293',
  },
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};